var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        size: "sm",
        id: "shareInvoiceModal",
        centered: "",
        "hide-footer": "",
        title: _vm.$t("send_invoice_modal_title"),
      },
      on: { hidden: _vm.clear },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "b-form",
        { staticClass: "share-invoice-form" },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                label: _vm.$t("send_invoice_modal_description"),
                "label-for": "EmailInput",
              },
            },
            [
              _c("b-form-input", {
                staticClass: "input-info-field",
                attrs: {
                  type: "email",
                  value: _vm.emailVal,
                  state: _vm.validEmail,
                  placeholder: "guest@domain.com",
                },
                model: {
                  value: _vm.emailVal,
                  callback: function ($$v) {
                    _vm.emailVal = $$v
                  },
                  expression: "emailVal",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.validEmail
            ? _c("b-tooltip", {
                attrs: {
                  target: "send-email-button-container",
                  placement: "top",
                  title: "Invalid Email",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { id: "send-email-button-container" } },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    disabled: !_vm.validEmail,
                    size: "md",
                    variant: "outline-primary",
                  },
                  on: { click: _vm.sendInvoiceEmail },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("send_invoice_modal_button")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }